import { render } from "./DatavanMPC.vue?vue&type=template&id=0fe1c46f"
import script from "./DatavanMPC.vue?vue&type=script&lang=js"
export * from "./DatavanMPC.vue?vue&type=script&lang=js"

import exportComponent from "C:\\ami-website\\www\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__